<div
  class="ai-chatbot-message ai-chatbot-message-{{ message.role }}"
  [class.ai-chatbot-message-presentations]="
    message.content?.type === 'template_tuner_create' ||
    message.content?.type === 'template_tuner_retrieve'
  "
>
  <div class="ai-chatbot-message-container">
    <span
      class="ai-chatbot-message-container-text"
      *ngIf="message.role === 'user' || message.role === 'error'"
    >
      {{ message.content?.displayMessage || message.content?.message }}
    </span>
    <span
      class="ai-chatbot-message-container-text"
      *ngIf="message.role === 'assistant'"
    >
      <span
        [innerHtml]="
          message.content?.displayMessage || message.content?.message
        "
      ></span>
      <ng-container
        *ngIf="
          message.content?.type === 'template_tuner_create' ||
          message.content?.type === 'template_tuner_retrieve'
        "
      >
        <strong>
          Select an option and let me know how I can make it better.</strong
        >
      </ng-container>
    </span>
    <button
      mat-icon-button
      class="ai-chatbot-message-container-resend"
      aria-label="Resend message"
      type="button"
      *ngIf="message.isNotSuccessful"
      (click)="aiChatbotService.sendMessage(message)"
    >
      <mat-icon
        svgIcon="restart"
        class="ai-chatbot-message-container-resend-icon"
      ></mat-icon>
    </button>
  </div>
  <div
    class="ai-chatbot-message-presentations"
    *ngIf="
      message.content?.type === 'template_tuner_create' ||
      message.content?.type === 'template_tuner_retrieve'
    "
  >
    <div class="ai-chatbot-message-presentations-row">
      <button
        type="button"
        *ngFor="let presentation of getTemplateTunerVariations(); let i = index"
        title="View {{ presentation.prompt }}"
        class="ai-chatbot-message-presentations-row-item"
        [class.ai-chatbot-message-presentations-row-item-selected]="
          isTemplateTunerOptionSelected(i)
        "
        [style.animation-delay.s]="i"
        tabindex="0"
        (click)="openTemplateTunerPreview(presentation, i)"
        [disabled]="aiChatbotService.isProcessing"
      >
        <div
          class="ai-chatbot-message-presentations-row-item-presentation"
          [class.portrait]="presentation.orientation === 'portrait'"
        >
          <presentation-preview
            [templatePreviewHtml]="presentation.content"
            [orientation]="presentation.orientation"
            [disableAutoRefresh]="true"
            [showBranding]="aiChatbotService.showBranding()"
          ></presentation-preview>
        </div>
      </button>
    </div>
  </div>

  <ai-chatbot-message-feedback
    *ngIf="message.role === 'assistant'"
    [messageId]="message.id"
    (thumbsUpClicked)="onThumbsUpClick($event)"
    (feedbackSent)="onFeedbackSent($event)"
  ></ai-chatbot-message-feedback>
</div>
